// extracted by mini-css-extract-plugin
export var box = "bhSXT";
export var boxContainer = "_93fMV";
export var buttonContainer = "TEGGi";
export var container = "yna-7";
export var description = "_1P4mS";
export var greenCheckmarkImage = "FQ1i4";
export var planBgImage = "_4iSMz";
export var planBgImageContainer = "SxZKR";
export var priceHeader = "yXxId";
export var sellingPointContainer = "ytaf8";
export var sellingPointTitle = "D7j9L";
export var sellingPointsParentContainer = "fgIGm";
export var title = "FJqQZ";
export var titleVariable = "FLnQD";